/* eslint-disable indent */
/**
 * Javascript for controlling the main menu
 * - open and close events
 * - scroll handlers
 * - focus trap
 */
import tippy from 'tippy.js';

export default function Tooltips() {
	var tt = this;

	/**
	 * Set up
	 */
	function _setup() {
    tippy('[data-tooltip]', {
      arrow: false,
      duration: [300, 250],
      placement: 'auto-start',
      offset: [0, 5],
      allowHTML: true,
      modifiers: [
        {
          name: 'flip',
          options: {
            fallbackPlacements: ['right', 'bottom']
          }
        }
      ],
      content(reference) {   
        let content = reference.getAttribute('data-tooltip'),
          contentEl = reference.querySelectorAll('.tooltip_content');     
        
        if (content.length) {
          // return data attribute if provided
          return content;
        } else if(contentEl.length) {
          // return inner span with class of tooltip_content
          return contentEl[0].innerHTML;
        }

        return null;
      }
    });
	}

	/**
	 * Start
	 */
	tt.start = function() {
		_setup();
	};

	return tt;
}